import { createFileRoute, redirect } from '@tanstack/react-router'
import CabinetSettingsPage from '@/views/cabinet-settings'
import { useAuthStore } from '@/stores/authStore'

export const Route = createFileRoute('/_authenticated/cabinet-settings')({
  beforeLoad: () => {
    const { auth } = useAuthStore.getState()
    // Only administrators can access this page
    if (!auth.user?.is_admin) {
      throw redirect({
        to: '/dashboard'
      })
    }
  },
  component: CabinetSettingsPage,
})
